if ($(".custoBlog").length) {
    var storageKey = "blogFeed-" + document.location.host;
    var storedNewsItems = sessionStorage.getItem(storageKey);

    if (storedNewsItems) {
        try {
            var newsItems = JSON.parse(storedNewsItems);

            displayNews(newsItems);
            readingTime();
        } catch (error) {
            console.error("❌ Chyba při načítání blogu ze sessionStorage:", error);

            sessionStorage.removeItem(storageKey);
            loadNewsFromURL();
        }
    } else {
        loadNewsFromURL();
    }
}

if ($(".type-posts-listing").length) {
    document.addEventListener("ShoptetDOMPageContentLoaded", function () {
        specialBlog();
    });

    $(document).ready(function () {
        specialBlog();
    });
}

/**
 * Získá jazyk z atributu:
 *
 * <html lang="cs">
 * <html lang="cs-CZ">
 * <html lang="de-AT">
 */
function getBlogLanguage() {
    var htmlLang = (document.documentElement.getAttribute("lang") || "").trim().toLowerCase().replace(/_/g, "-");

    var languageMap = {
        cs: "cs",
        "cs-cz": "cs",

        sk: "sk",
        "sk-sk": "sk",

        de: "de",
        "de-de": "de",
        "de-at": "de-at",

        pl: "pl",
        "pl-pl": "pl",

        nl: "nl",
        "nl-nl": "nl",

        fr: "fr",
        "fr-fr": "fr",
    };

    if (languageMap[htmlLang]) {
        return languageMap[htmlLang];
    }

    var primaryLanguage = htmlLang.split("-")[0];

    return languageMap[primaryLanguage] || "";
}

/**
 * Normalizuje URL článku na cestu.
 *
 * Například:
 *
 * https://www.celtic-supply.cz/blog/clanek/
 * /blog/clanek
 *
 * převede na:
 *
 * /blog/clanek/
 */
function normalizeArticlePath(url) {
    if (!url) {
        return "";
    }

    try {
        var parsedUrl = new URL(url, window.location.origin);

        var path = parsedUrl.pathname;

        if (path !== "/" && !path.endsWith("/")) {
            path += "/";
        }

        return path;
    } catch (error) {
        return "";
    }
}

/**
 * Doplní tlačítko článku na stránce výpisu blogu.
 */
function specialBlog() {
    $("#newsWrapper .news-item").each(function () {
        var $newsItem = $(this);
        var $title = $newsItem.find("a.title").first();
        var $text = $newsItem.find(".text").first();

        if (!$title.length || !$text.length) {
            return;
        }

        if (!$text.find(".textBottom").length) {
            $text.append('<div class="textBottom">' + '<a href="' + $title.attr("href") + '" class="btn btn-third">' + translation("precistClanek") + "</a>" + "</div>");
        }
    });

    readingTime();
}

/**
 * Načte první čtyři články z blogu.
 */
function loadNewsFromURL() {
    var url = "/blog/";

    $.get(url)
        .done(function (data) {
            var $data = $(data);

            var $newsItems = $data.find("#newsWrapper .news-item").slice(0, 4);

            var newsItemHTML = $newsItems
                .map(function () {
                    return this.outerHTML;
                })
                .get();

            sessionStorage.setItem("blogFeed-" + document.location.host, JSON.stringify(newsItemHTML));

            displayNews(newsItemHTML);
            readingTime();
        })
        .fail(function (xhr, status, error) {
            console.error("❌ Chyba při načítání blogu:", status, error);
        });
}

/**
 * Zobrazí články v bloku .custoBlog.
 */
function displayNews(newsItems) {
    var $blogFeed = $(".custoBlog .blogFeed");

    $blogFeed.empty().append(newsItems);

    $blogFeed.find(".news-item").each(function () {
        var $newsItem = $(this);
        var $image = $newsItem.find("img").first();
        var $title = $newsItem.find("a.title").first();
        var $text = $newsItem.find(".text").first();

        if ($image.length) {
            var imageSrc = $image.attr("data-src") || $image.attr("src");

            if (imageSrc) {
                $image.attr("src", imageSrc);
            }
        }

        if ($title.length && $text.length && !$text.find(".textBottom").length) {
            $text.append('<div class="textBottom">' + '<a href="' + $title.attr("href") + '" class="btn btn-third">' + translation("precistClanek") + "</a>" + "</div>");
        }
    });
}

/*
 * Uložený AJAX request zabrání tomu, aby se stejné API
 * načítalo několikrát při opakovaném volání readingTime().
 */
var readingTimeRequest = null;
var readingTimeCache = null;
var readingTimeLanguage = null;

/**
 * Načte časy čtení podle jazyka aktuální stránky.
 */
function readingTime() {
    var apiUrl = "https://php.shopcode.cz/api/celtic-supply/api-blog_reading_time.php";

    var currentLanguage = getBlogLanguage();

    if (!currentLanguage) {
        console.warn('⚠️ Nepodařilo se zjistit podporovaný jazyk z atributu <html lang="">.');

        return;
    }

    /*
     * Pokud už máme data pro stejný jazyk,
     * pouze je znovu aplikujeme na aktuální články.
     */
    if (readingTimeCache && readingTimeLanguage === currentLanguage) {
        applyReadingTimes(readingTimeCache, currentLanguage);

        return;
    }

    /*
     * Pokud už API požadavek běží, nespouštíme další.
     */
    if (readingTimeRequest) {
        return;
    }

    readingTimeRequest = $.ajax({
        url: apiUrl,
        method: "GET",
        dataType: "json",
        cache: false,
        data: {
            lang: currentLanguage,
            limit: 500,
        },
    })
        .done(function (resp) {
            if (!resp || !Array.isArray(resp.data)) {
                console.warn("⚠️ API nevrátilo očekávaná data.", resp);

                return;
            }

            readingTimeCache = resp.data;
            readingTimeLanguage = currentLanguage;

            applyReadingTimes(resp.data, currentLanguage);
        })
        .fail(function (xhr, status, error) {
            console.error("❌ Chyba při načítání API:", {
                status: status,
                error: error,
                response: xhr.responseText,
                language: currentLanguage,
            });
        })
        .always(function () {
            readingTimeRequest = null;
        });
}

/**
 * Doplní načtené časy čtení do článků na stránce.
 */
function applyReadingTimes(items, currentLanguage) {
    if (!Array.isArray(items) || !items.length) {
        return;
    }

    /*
     * Vytvoření mapy:
     *
     * /blog/nazev-clanku/ → data článku
     */
    var articlesByPath = {};

    items.forEach(function (item) {
        var articlePath = normalizeArticlePath(item.url);

        if (!articlePath) {
            return;
        }

        articlesByPath[articlePath] = item;
    });

    $(".news-item a.title").each(function () {
        var $link = $(this);
        var href = $link.attr("href");

        if (!href) {
            return;
        }

        var articlePath = normalizeArticlePath(href);
        var item = articlesByPath[articlePath];

        if (!item) {
            return;
        }

        var minutes = parseInt(item.reading_minutes, 10);

        if (!Number.isFinite(minutes) || minutes < 1) {
            return;
        }

        var readingText = sklonujMinuty(minutes, currentLanguage);

        if (!readingText) {
            return;
        }

        var $newsItem = $link.closest(".news-item");

        /*
         * Pokud čas už existuje, pouze aktualizujeme text.
         */
        var $readingTime = $newsItem.find(".reading-time").first();

        if ($readingTime.length) {
            $readingTime.text(readingText);
            return;
        }

        var $target = $newsItem.find(".text .textBottom").first();

        /*
         * Záloha pro případ, že .textBottom ještě neexistuje.
         */
        if (!$target.length) {
            var $text = $newsItem.find(".text").first();

            if (!$text.length) {
                return;
            }

            $text.append('<div class="textBottom"></div>');

            $target = $text.find(".textBottom").first();
        }

        $("<p>", {
            class: "reading-time",
            text: readingText,
        }).appendTo($target);
    });
}

/**
 * Vrátí text času čtení podle jazyka stránky.
 */
function sklonujMinuty(minutes, language) {
    var value = parseInt(minutes, 10);

    if (!Number.isFinite(value) || value < 1) {
        return "";
    }

    switch (language) {
        case "cs":
            if (value === 1) {
                return "1 min. čtení";
            }

            if (value >= 2 && value <= 4) {
                return value + " min. čtení";
            }

            return value + " min. čtení";

        case "sk":
            if (value === 1) {
                return "1 min. čítania";
            }

            if (value >= 2 && value <= 4) {
                return value + " min. čítania";
            }

            return value + " min. čítania";

        case "de":
        case "de-at":
            if (value === 1) {
                return "1 Min. Lesezeit";
            }

            return value + " Min. Lesezeit";

        case "pl":
            return value + " min.";

        case "nl":
            if (value === 1) {
                return "1 min. lezen";
            }

            return value + " min. lezen";

        case "fr":
            if (value === 1) {
                return "1 min. de lecture";
            }

            return value + " min. de lecture";

        default:
            return value + " min";
    }
}
